window.firstDragImagesAnimation = function firstDragImagesAnimation() {
  const container = document.querySelector('.drag-container'); // большой bounds
  const positionContainer = document.querySelector('.drag-container-position'); // контейнер с позициями
  const imagesElArr = container?.querySelectorAll('.drag-item');

  if (!container || !positionContainer || !imagesElArr?.length) return;

  gsap.registerPlugin(Draggable, InertiaPlugin);

  const draggables = [];
  const startPositions = [];

  imagesElArr.forEach((imageEl) => {
    const rect = imageEl.getBoundingClientRect();
    const containerRect = positionContainer.getBoundingClientRect();
    startPositions.push({
      x: rect.left - containerRect.left,
      y: rect.top - containerRect.top,
    });
  });

  const setImages = () => {
    const positionRect = positionContainer.getBoundingClientRect();

    imagesElArr.forEach((imageEl, i) => {
      const pos = startPositions[i];
      const x = pos.x * (positionRect.width / positionRect.width);
      const y = pos.y * (positionRect.height / positionRect.height);

      gsap.set(imageEl, {
        x,
        y,
        top: 0,
        left: 0,
        position: 'absolute',
      });

      if (!draggables[i]) {
        draggables[i] = Draggable.create(imageEl, {
          type: 'x,y',
          bounds: container,
          edgeResistance: 0.75,
          inertia: true,
          maxDuration: 0.5,
          minDuration: 0.1,
        })[0];
      } else {
        draggables[i].applyBounds(container);
        draggables[i].update();
      }
    });
  };

  setImages();

  window.addEventListener('resize', () => {
    setImages();
  });
};

window.firstDragWrImagesAnimation = function firstDragWrImagesAnimation() {
  const imgWrElArr = document.querySelectorAll('.drag-item .drag-item-img');
  if (!imgWrElArr.length) return;

  const startDelay = 800;
  const intervalDelay = 400;

  const remaining = [...imgWrElArr];

  let timeoutId = setTimeout(function addRandom() {
    if (!remaining.length) return;

    const randomIndex = Math.floor(Math.random() * remaining.length);
    const el = remaining.splice(randomIndex, 1)[0];

    el.classList.add('is-start-animation');

    if (remaining.length) {
      timeoutId = setTimeout(addRandom, intervalDelay);
    }
  }, startDelay);
};
